module.exports = __webpack_public_path__ + "static/media/logo-2.b566f2bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-2.png
// module id = 389
// module chunks = 0